module.exports = __webpack_public_path__ + "img/syntheseReco.8f3421f3.jpg";